<div
	id="kt_create_pwa"
	class="bg-body"
	data-kt-drawer="true"
	data-kt-drawer-name="create_company_pwa"
	data-kt-drawer-activate="true"
	data-kt-drawer-overlay="true"
	data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
	data-kt-drawer-direction="end"
	data-kt-drawer-toggle="#kt_create_pwa_toggle"
	data-kt-drawer-close="#kt_create_pwa_close"
>
	<div class="card shadow-none rounded-0 w-100">
		<!-- Header -->
		<div class="card-header" id="kt_create_pwa_header">
			<h3 class="card-title fw-bolder text-gray-900">
				{{ (pwa$ | async) ? ('edit_pwa_drawer_title' | translate) : ('create_pwa_drawer_title' | translate) }}
			</h3>
			<span class="text-muted fs-7 fw-semibold" translate>create_edit_pwa_drawer_description</span>
		</div>

		<!-- Body -->
		<div class="card-body position-relative" id="kt_create_pwa_body">
			<div
				id="kt_create_pwa_scroll"
				class="position-relative scroll-y me-n5 pe-5"
				data-kt-scroll="true"
				data-kt-scroll-height="auto"
				data-kt-scroll-wrappers="#kt_create_pwa_body"
				data-kt-scroll-dependencies="#kt_create_pwa_header, #kt_create_pwa_footer"
				data-kt-scroll-offset="0px"
			>
				<form [formGroup]="form">
					<!-- Name -->
					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_pwa_form_label_name</label>
						<input type="text" formControlName="name" class="form-control form-control-solid" placeholder="{{ 'create_pwa_form_placeholder_name' | translate }}" />
						<div *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched" class="fv-plugins-message-container invalid-feedback" translate>error_required_field</div>
					</div>

					<!-- Logotype file -->
					<div class="px-2 mb-10">
						<div class="d-flex flex-column">
							<label class="form-label mb-3" translate>create_pwa_form_label_logo</label>
							<button type="button" class="btn btn-light rounded h-200px bg-hover-light-dark w-100 p-0 position-relative" (click)="openFilesGalery()">
								@if (!selectedLogotype?.path) {
									<div class="p-10 d-flex justify-content-center align-items-center text-muted h-100" translate>create_pwa_form_label_image</div>
								} @else {
									<div class="position-absolute top-0 end-0 m-2">
										<button
											type="button"
											class="btn btn-icon btn-icon-primary btn-bg-light btn-active-light-danger btn-active-color-danger ms-2"
											(click)="removeTerminalLogo($event)"
										>
											<app-keenicon name="trash" class="fs-3 text-danger text-hover-danger"></app-keenicon>
										</button>
									</div>

									<img class="pay-imgs rounded pay-obj-fit h-100 w-100" [src]="selectedLogotype.path" [alt]="selectedLogotype.name" />
								}
							</button>
						</div>
					</div>

					<!-- Cover file -->
					<div class="px-2 mb-10">
						<div class="d-flex flex-column">
							<label class="form-label mb-3" translate>create_pwa_form_label_cover</label>
							<button type="button" class="btn btn-light rounded h-200px bg-hover-light-dark w-100 p-0 position-relative" (click)="openCoverGallery()">
								@if (!selectedCover?.path) {
									<div class="p-10 d-flex justify-content-center align-items-center text-muted h-100" translate>create_pwa_form_label_image</div>
								} @else {
									<div class="position-absolute top-0 end-0 m-2">
										<button type="button" class="btn btn-icon btn-icon-primary btn-bg-light btn-active-light-danger btn-active-color-danger ms-2" (click)="removeCoverLogo($event)">
											<app-keenicon name="trash" class="fs-3 text-danger text-hover-danger"></app-keenicon>
										</button>
									</div>

									<img class="pay-imgs rounded pay-obj-fit h-100 w-100" [src]="selectedCover.path" [alt]="selectedCover.name" />
								}
							</button>
						</div>
					</div>

					<!-- Loupe ID -->
					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_pwa_form_label_luope_id</label>
						<input type="text" formControlName="luopeId" class="form-control form-control-solid" placeholder="{{ 'create_pwa_form_placeholder_luope_id' | translate }}" />

						<div *ngIf="form.get('luopeId')?.hasError('required') && form.get('luopeId')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
							error_required_field
						</div>
					</div>

					<!-- Shared Key -->
					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_pwa_form_label_shared_key</label>
						<input type="text" formControlName="sharedKey" class="form-control form-control-solid" placeholder="{{ 'create_pwa_form_placeholder_shared_key' | translate }}" />
						<div *ngIf="form.get('sharedKey')?.hasError('required') && form.get('sharedKey')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
							error_required_field
						</div>
					</div>

					<!-- Subdomain -->
					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_pwa_form_label_subdomain</label>
						<input type="text" formControlName="subdomain" class="form-control form-control-solid" placeholder="{{ 'create_pwa_form_placeholder_subdomain' | translate }}" />
						<div *ngIf="form.get('subdomain')?.hasError('required') && form.get('subdomain')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
							error_required_field
						</div>
					</div>
					<!-- Final Message Switch -->
					<div class="fv-row mb-7">
						<label class="fw-semibold fs-6 mb-2" translate>create_pwa_form_label_final_message_switch</label>
						<div class="form-check form-switch form-check-custom form-check-solid justify-content-between">
							<input type="checkbox" formControlName="activeFinalMessage" class="form-check-input cursor-pointer" />
						</div>
					</div>

					<!-- Final Message -->
					<div *ngIf="form.get('activeFinalMessage')?.value" class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_pwa_form_label_final_message</label>
						<input type="text" formControlName="finalMessage" class="form-control form-control-solid" placeholder="{{ 'create_pwa_form_placeholder_final_message' | translate }}" />
						<div *ngIf="!isFinalMessageValid" class="fv-plugins-message-container invalid-feedback" translate>error_required_field</div>
					</div>
				</form>
				<div class="col-12 mb-10 fv-row">
					<!-- Accordion -->
					<mat-accordion class="wallet-accordion" multi>
						<!-- Customization -->
						<mat-expansion-panel>
							<mat-expansion-panel-header>
								<mat-panel-title>
									<span class="pay-panel-title" translate>create_pwa_form_label_customization</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<!-- Color -->
							<div class="col-md-12 mb-5">
								<div class="d-flex justify-content-between align-items-center mb-3 p-1">
									<label class="fw-semibold text-label" translate>create_pwa_form_label_color</label>

									<button *ngIf="!isDefaultTheme" (click)="resetTheme()" class="hover-elevate-up btn btn-primary d-flex justify-content-between round py-3">
										<span class="text-white font-size-sm me-2" translate>reset_theme</span>
										<app-keenicon name="arrows-circle" type="solid" class="fs-3 text-white"></app-keenicon>
									</button>
								</div>
								<div class="row">
									@for (property of defaultThemeArray.properties; track property.name) {
										<div class="col-md-12 mb-0">
											<div class="d-flex align-items-center mb-3 create-theme-pwa-bg rounded p-4">
												<div class="d-flex flex-column">
													<div class="fs-6 fw-bold text-label" translate>
														{{ property.label }}
														<button *ngIf="!this.isDefaultValue(property)" class="ms-1" (click)="resetToDefault(property)">
															<app-keenicon name="arrows-circle" type="solid" [class]="'ms-2 text-action-primary fs-5'"></app-keenicon>
														</button>
													</div>
													<span class="fs-7 text-secondary-label" translate>{{ property.description }}</span>
												</div>

												<div class="d-flex align-items-center ms-auto">
													<div style="width: 200px" *ngIf="property.type === PwaThemePropertyTypeEnum.COLOR">
														@if (typeof property.value === 'string') {
															<input
																type="text"
																[placeholder]="property.value"
																[colorPicker]="property.value"
																[cpAlphaChannel]="'always'"
																[cpDisableInput]="true"
																[cpOutputFormat]="'hex'"
																(colorPickerChange)="updateThemeProperty($event, property)"
																[cpToggle]="true"
																[cpPosition]="'top'"
																class="form-control form-control-sm border"
																[style.background]="property.value"
															/>
														}
													</div>
												</div>
											</div>
										</div>
									}
								</div>
							</div>
						</mat-expansion-panel>
					</mat-accordion>
				</div>
			</div>
		</div>

		<!-- Footer -->
		<div class="card-footer py-5 d-flex justify-content-between align-items-center" id="kt_create_pwa_footer">
			<button id="kt_create_pwa_close" type="button" class="hover-elevate-up btn btn-light d-flex justify-content-between round py-4">
				<app-keenicon name="to-left" class="fs-3 text-muted me-3"></app-keenicon>
				<span class="text-muted font-size-sm" translate>drawer_back</span>
			</button>

			<button type="button" class="hover-elevate-up btn btn-primary d-flex justify-content-between round py-4" (click)="save()" [disabled]="form.invalid">
				<span class="text-white font-size-sm me-2">
					{{ pwa?.uuid ? ('update_pwa' | translate) : ('create_pwa' | translate) }}
				</span>
				<app-keenicon name="rocket" class="fs-3 text-white"></app-keenicon>
			</button>
		</div>
	</div>
</div>
